import { render } from "./ArticleDataComp.vue?vue&type=template&id=59978d94&scoped=true"
import script from "./ArticleDataComp.vue?vue&type=script&lang=js"
export * from "./ArticleDataComp.vue?vue&type=script&lang=js"

import "./ArticleDataComp.vue?vue&type=style&index=0&id=59978d94&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59978d94"]])

export default __exports__